import { defineStore } from 'pinia'

import { StorageHelper } from '@/helpers/storage-helper'
import { RepositoryFactory } from '@/repositories/repositoryFactory'

interface AppError {
  message: string
}

interface TermsAndConditionsData {
  data: any
  loading: boolean
  error: AppError | null
  initialized: boolean
}

const TermsAndConditionsRepository: any = RepositoryFactory.get('TermsAndConditionsRepository')

export const useTermsAndConditionsStore = defineStore('termsAndConditions', {
  state: () =>
    <TermsAndConditionsData>{
      data: StorageHelper.getItem('termsAndConditionsData', []),
      error: null,
      loading: true
    },
  getters: {
    getTermsAndConditionsData: (state) => state.data
  },
  actions: {
    async fetchTermsAndConditionsData(slug: string, template: string) {
      this.loading = true
      try {
        this.data = (
          await TermsAndConditionsRepository.getPageTypeOneBySlug({}, slug, template)
        ).data.fields
        StorageHelper.setItem('termsAndConditionsData', this.data)
      } catch (error) {
        console.error('Error fetching:', error)
        this.error = {
          message: 'problem with fetching terms and conditions data'
        }
        throw error
      } finally {
        this.loading = false
      }
    }
  }
})
